import tableWrapperInit from './tableWrapper'
import cardWidthInit from './cardWidth'
import paddingInit from './paddings'

window.onload = () => {
  tableWrapperInit()
  cardWidthInit()
  paddingInit()
}



// WEBPACK FOOTER //
// ./src/js/scripts/index.js